import { AddTeamComponent } from '../add-team/add-team.component';
import { EditTeamComponent } from '../edit-team/edit-team.component';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DocumentReference, SportTeam, FestivalUser } from 'src/core/models';
import {
  AgeGroupService, ArrayService, AuthService, ChurchService, 
  DatabaseService, DocumentService, SportTeamService, FestivalUserService
} from 'src/core/services';
import { ModalController, NavController, AlertController, LoadingController } from '@ionic/angular';
import { Sport } from 'src/core/enums';
import { PageClass } from 'src/core/classes/page';

@Component({
  selector: 'app-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.less', '../../core/styles/common.less']
})

export class TeamListComponent extends PageClass implements OnInit {

  currentUser: FestivalUser;

  sportTeamList: SportTeam[];
  sportTeamList$: Observable<SportTeam[]>;

  //churchList$: Observable<Church[]>;
  //churchList: DocumentReference[];
  allChurches: DocumentReference;

  filter: any = { filterSport: undefined, filterChurch: undefined };
  sportList: any[];
  isLoading = true;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private docService: DocumentService,
    private router: Router,
    private sportTeamService: SportTeamService,
    protected festivalUserService: FestivalUserService,
    protected navController: NavController,
    protected modalController: ModalController,
    protected alertController: AlertController,
    protected loadingController: LoadingController
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {
    this.sportList = this.currentUser.isAdmin ? this.sportTeamService.getSportList() : this.currentUser.sportList;

    this.filter.filterSport = this.getFilterSport();
    
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {

      if (this.currentUser.isAdmin || this.currentUser.isSportLeader) {
        this.allChurches = {
          displayName: 'All Churches',
          reference: new DocumentReference()
        };

        this.filter.filterChurch = localStorage.getItem('filteredChurch') ? 
        this.churchList.find(c => c.reference.id == localStorage.getItem('filteredChurch')) : 
        this.churchList[0];

        if (this.filter.filterChurch == null)
          this.filter.filterChurch = this.churchList[0];

      this.getTeamList();
      } else {
        // this.churchList.push(this.currentUser.church);
        this.filter.filterChurch = this.currentUser.church;
        this.getTeamList();
      }
    }
  }

  private getFilterSport = (): any => { 
    return localStorage.getItem('filteredSport') ? 
        this.sportList.find(s => s.value == localStorage.getItem('filteredSport')).value : 
        this.sportList[0].value;
  }

  getTeamList = async () => {

    // Save Filters
    localStorage.setItem('filteredChurch', this.filter.filterChurch.reference.id);
    localStorage.setItem('filteredSport', this.filter.filterSport);

    this.sportTeamList = [];
    this.sportTeamList$ = this.sportTeamService.getSportTeams(
      this.filter.filterChurch,
      this.filter.filterSport
    );

    this.sportTeamList$
      .subscribe(sportTeamList => {
        this.sportTeamList = sportTeamList;

        this.sportTeamList.forEach(team => {
          team.sportName = Sport[team.sport];
        });

        this.isLoading = false;
      });
  }

  addSportTeam = async (churchList: DocumentReference[], ageGroupList: DocumentReference[]) => {
    const modal = await this.modalController.create({
      component: AddTeamComponent,
      componentProps: {
        churchList,
        ageGroupList
      }
    });
    return await modal.present();
  }

  editSportTeam = async (sportTeam: SportTeam) => {
    const modal = await this.modalController.create({
      component: EditTeamComponent,
      componentProps: {
        sportTeam
      }
    });
    return await modal.present();
  }

  deleteSportTeam = (sportTeam: SportTeam): void => {
    this.docService.deleteDocument('sportTeams', sportTeam.id);
  }
}
